<script>
import { pagePanierEmits, pagePanierProps, usePagePanier } from "./mixin";
import PanierVide from "@/components/organisms/panier-vide";
import ProductCategory from "@/components/organisms/product-category";
import ItemContainer from "@/containers/panier/item";
import OrderSummary from "@/containers/order-summary/panier";
import Container from "@/components/atoms/container";
import Card from "@/components/molecules/card";
import ButtonIcon from "@/components/molecules/button-icon";
import ButtonGroup from "@/components/molecules/button-group";
import Popin from "@/containers/popin-adaptive";
import PanierToListeForm from "@/containers/panier-to-liste-form";
import Icon from "@/components/atoms/icon";
import Accordion from "@/components/molecules/accordion";
import PopinViderPanier from "@/components/organisms/popins-compte/popin-vider-panier";
import PushProductsBlock from "@/components/organisms/push-products-block/default";
import Divider from "@/components/atoms/divider";
import AbonnementLadBanniereRenouvellement from "@/components/organisms/abonnement-lad/panier/renouvellement/default";
import AbonnementLadBanniereNonAbonne from "@/components/organisms/abonnement-lad/panier/non-abonne";
import AbonnementLadBanniereAbonne from "@/components/organisms/abonnement-lad/panier/abonne";
import PopinAnchor from "@/components/molecules/popin-anchor";
import Titre from "@/components/atoms/titre";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import {
  ABO_LAD_OTHER_COOKIE_NAME,
  useAbonnementLadBanner
} from "@/composables/abonnement-lad";

import ProductCategoryItem from "@/components/organisms/product-category/product-category-item/default";
import ProductCategoryItemAbonnement from "@/components/organisms/product-category/product-category-item/abonnement/default";

export default {
  name: "Panier",
  components: {
    PanierVide,
    ProductCategory,
    OrderSummary,
    Container,
    Card,
    ButtonIcon,
    ButtonGroup,
    Popin,
    ItemContainer,
    PanierToListeForm,
    Icon,
    Accordion,
    PopinViderPanier,
    Divider,
    AbonnementLadBanniereRenouvellement,
    AbonnementLadBanniereNonAbonne,
    AbonnementLadBanniereAbonne,
    PopinAnchor,
    PushProductsBlock,
    Titre,
    HtmlParser
  },
  props: {
    ...pagePanierProps()
  },
  emits: [...pagePanierEmits()],
  setup(props, context) {
    const { isClosedLad, closeLadBanner } = useAbonnementLadBanner(
      ABO_LAD_OTHER_COOKIE_NAME
    );
    const {
      Panierpagecodes,
      smartliste,
      pushListDevantCaisse,
      articleQuantite,
      isAllSubstitutionAccord,
      hasAbonnementInPanier,
      dispoPremierCreneau,
      isEligibleAbonnementLad,
      isPro,
      aboLadMaxAtteint,
      showRecettes,
      showSubstitution,
      typePanierLabel,
      typePanierIcon,
      lignesBySections,
      nbProduits,
      articlesIndisponibles,
      abonnementInCurrentMagasin,
      abonnementExpireInCurrentMagasin,
      montantManquantLAD,
      delaisCCInHours,
      setSubstitutionAccordPanier,
      goTunnel,
      clearCart,
      getNbProduits,
      getPushProducts,
      getPushData,
      getPushTitle,
      mounted,
      created
    } = usePagePanier(props, context);

    onMounted(mounted);

    created();

    const pushListPanierProduits = getPushProducts(
      Panierpagecodes.PANIER_PRODUITS,
      1
    )
      .filter((article) => articleQuantite.value(article.id) === 0)
      .slice(0, 5);

    return {
      isClosedLad,
      closeLadBanner,
      Panierpagecodes,
      smartliste,
      pushListDevantCaisse,
      articleQuantite,
      isAllSubstitutionAccord,
      hasAbonnementInPanier,
      dispoPremierCreneau,
      isEligibleAbonnementLad,
      isPro,
      aboLadMaxAtteint,
      showRecettes,
      showSubstitution,
      typePanierLabel,
      typePanierIcon,
      lignesBySections,
      nbProduits,
      articlesIndisponibles,
      abonnementInCurrentMagasin,
      abonnementExpireInCurrentMagasin,
      montantManquantLAD,
      delaisCCInHours,
      setSubstitutionAccordPanier,
      goTunnel,
      clearCart,
      getNbProduits,
      getPushProducts,
      getPushData,
      getPushTitle,
      ProductCategoryItem,
      ProductCategoryItemAbonnement,
      pushListPanierProduits
    };
  },
  methods: {
    showLdc() {
      if (this.$refs.addToListe) {
        this.$refs.addToListe.show();
      }
    }
  }
};
</script>

<template>
  <Container>
    <PopinViderPanier
      ref="confirmClear"
      :type-panier="typePanier"
      @validate="clearCart()"
    />
    <div v-if="nbProduits == 0 && (!articlesIndisponibles || articlesIndisponibles.length == 0)">
      <div class="u-flex u-flex-align-baseline u-mt-sm">
        <h1 class="u-font-28">
          Mon panier
        </h1>
        <p class="u-font-secondary u-font-700 u-font-15 u-ml-xs">
          (0 produit)
        </p>
      </div>
      <PanierVide :type-panier="typePanier" />
    </div>
    <template v-else>
      <div class="u-flex u-flex-align-start">
        <div class="u-mr-lg u-min-width-0 u-full-width">
          <template v-if="!isPro">
            <div
              v-if="typePanier === 'click_and_collect'"
              class="u-py-md"
            >
              <div class="u-flex u-flex-justify-center u-flex-align-center u-font-15">
                <Icon
                  v-if="delaisCCInHours === 2"
                  name="chrono"
                  class="u-mr-xs u-flex u-flex-self-start u-flex-shrink-none"
                  size="md"
                  variant="primary"
                />
                <div>
                  Disponible à partir de :
                  <span class="u-font-500 u-full-width@sm u-text-center@sm u-ml-xxs u-ml-none@sm">
                    {{ dispoPremierCreneau("CC") }}
                  </span>
                </div>
              </div>
              <div class="u-flex u-flex-justify-center u-font-18 u-mt-sm">
                Commandez en ligne et retirez votre commande gratuitement en
                magasin {{ delaisCCInHours }}h après !
              </div>
            </div>
            <div
              v-else-if="typePanier === 'click_and_collect_traiteur_noel'"
              class="u-pt-lg u-pb-md"
            >
              <div class="u-flex u-flex-justify-center u-flex-align-center u-font-15 u-mb-sm">
                <div>
                  Disponible à partir de :
                  <span class="u-font-500 u-full-width@sm u-text-center@sm u-ml-xxs u-ml-none@sm">
                    {{ dispoPremierCreneau("CC_TRAITEUR_NOEL") }}
                  </span>
                </div>
              </div>
              <div class="u-flex u-flex-justify-center u-font-18 u-mb-xs25">
                Commandez en ligne dès maintenant et retirez votre commande au
                moment des fêtes !
              </div>
              <div class="u-flex u-flex-justify-center u-font-14 u-mb-xxs">
                • Retrait le 23 ou le 24 Décembre, pour toute commande
                effectuée avant le 17 Décembre à 12h00
              </div>
              <div class="u-flex u-flex-justify-center u-font-14">
                • Retrait le 30 ou le 31 Décembre, pour toute commande
                effectuée avant le 23 Décembre à 12h00
              </div>
            </div>
            <div
              v-else-if="typePanier === 'click_and_collect_traiteur_permanent'"
              class="u-flex u-flex-justify-center u-text-center u-pt-sm u-flex-align-center u-font-15 Desk_Panier_Creneaux"
            >
              <Icon
                name="click-collect"
                class="u-mr-xs u-flex u-flex-self-start u-flex-shrink-none"
                size="md"
                variant="primary"
              />
              <div class="u-text-left">
                Prochain créneau disponible :
                <span class="u-font-500 u-full-width@sm u-text-center@sm u-ml-xxs u-ml-none@sm">
                  {{ dispoPremierCreneau("CC_TRAITEUR_PERMANENT") }}
                </span>
              </div>
            </div>
            <div
              v-else-if="typePanier === 'ldd'"
              class="u-flex u-flex-justify-center u-text-center u-pt-sm u-pb-xs"
            >
              <div class="u-flex u-flex-align-center u-font-15">
                <Icon
                  name="exclu-web"
                  class="u-mr-xs u-flex u-flex-self-start u-flex-shrink-none"
                  size="md"
                  variant="primary"
                />
                <div class="u-text-left">
                  Livraison à domicile uniquement
                </div>
              </div>
            </div>
            <div
              v-else
              class="u-flex u-flex-justify-center u-text-center u-pt-sm Desk_Panier_Creneaux"
            >
              <div class="u-flex u-flex-column">
                <div class="u-flex u-flex-align-center u-font-15 u-mb-xs">
                  <Icon
                    name="shipping-drv"
                    class="u-mr-xs u-flex u-flex-self-start u-flex-shrink-none"
                    size="md"
                    variant="primary"
                  />
                  <div class="u-text-left">
                    Prochain créneau drive :
                    <span class="u-font-500 u-full-width@sm u-text-center@sm u-ml-xxs u-ml-none@sm">
                      {{ dispoPremierCreneau() }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="dispoPremierCreneau('LAD')"
                  class="u-flex u-flex-align-center u-font-15"
                >
                  <Icon
                    name="shipping-lad"
                    class="u-mr-xs u-flex u-flex-self-start u-flex-shrink-none"
                    size="md"
                    variant="primary"
                  />
                  <div class="u-text-left">
                    Prochain créneau livraison :
                    <span class="u-font-500 u-full-width@sm u-text-center@sm u-ml-xxs u-ml-none@sm">
                      {{ dispoPremierCreneau("LAD") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <Divider dotted />
          </template>

          <div class="u-flex u-flex-column@md u-flex-align-center u-flex-align-start@md u-mb-md  u-mt-md Desk_Panier_Titre">
            <div class="u-flex u-flex-align-baseline u-mr-xs u-mb-xs@md">
              <Icon
                :name="typePanierIcon"
                class="u-mr-xs25 u-flex u-flex-self-start u-flex-shrink-none"
                size="md"
                variant="black"
              />
              <div class="u-flex u-flex-wrap u-flex-align-baseline">
                <h1 class="u-font-28">
                  Mon panier {{ typePanierLabel }}
                </h1>
                <p class="u-font-secondary u-font-700 u-font-15 u-ml-xs">
                  ({{ nbProduits }} {{ pluralize(nbProduits, "produit") }})
                </p>
              </div>
            </div>
            <ButtonIcon
              icon-name="mes-listes"
              icon-placement="left"
              icon-color="primary"
              icon-color-hover="white"
              size="sm"
              outline
              radius="full"
              variant="primary"
              icon-size="md"
              class="u-mt-xs u-mt-none@md"
              @click="$needAuth(showLdc)"
            >
              Enregistrer mon panier comme liste
            </ButtonIcon>
          </div>
          <p
            v-if="showSubstitution"
            class="u-mb-md"
          >
            Le service de substitution est uniquement disponible pour les commandes Drive et en Livraison à domicile.
            <PopinAnchor
              open-on-hover
              link
              infobulle
              popin-size="lg"
              position="bottom-left"
            >
              <template #button-content>
                <span>En savoir plus </span>
              </template>
              <p>
                En autorisant la substitution, vous vous assurez de repartir
                avec toutes vos courses même si un produit est manquant lors
                de la préparation de votre commande.
                <br />
                Lors du retrait ou de la livraison, un produit de remplacement
                équivalent vous sera présenté, que vous pourrez accepter ou
                refuser.
                <br />
                Vous ne payerez pas plus cher, Cora prend en charge la
                différence de prix.
                <br />
                <b>Hors commande en Point de retrait, Casier de retrait, Easybox, Livraison collaborative, Drive piéton et Livraison en entreprise.</b>
              </p>
            </PopinAnchor>
          </p>
          <Accordion>
            <Card
              v-if="articlesIndisponibles.length > 0"
              class="c-panier__card"
            >
              <ProductCategory class="c-panier__category">
                <template #title>
                  <h2 class="c-panier__category-title">
                    {{ pluralize(articlesIndisponibles.length, "Produit") }}
                    {{ pluralize(articlesIndisponibles.length, "indisponible") }}
                    <span class="c-panier__category-title-quantity">
                      ({{ articlesIndisponibles.length }}
                      {{ pluralize(articlesIndisponibles.length, "produit") }})
                    </span>
                  </h2>
                </template>
                <template #subtitle>
                  <div class="u-flex">
                    <Icon
                      name="alert-circle-outline"
                      variant="alert"
                      size="sm"
                      class="u-mr-sm u-mb-md"
                    />
                    <p class="u-color-grey-1 u-font-14">
                      Les produits suivants ne sont pas disponibles actuellement.
                      Il seront retirés de votre commande. <br />
                      Vous pouvez choisir parmi les produits suggérés pour les
                      remplacer.
                    </p>
                  </div>
                </template>
                <ItemContainer
                  v-for="(article, index) in articlesIndisponibles"
                  :key="`${index}-${article.id}`"
                  :component="ProductCategoryItem"
                  :article="article"
                  :show-substitution="showSubstitution"
                  :type-panier="typePanier"
                  :cart-context="trackingCodes.LABELGA.Panier"
                  class="c-panier__product"
                />
              </ProductCategory>
            </Card>
            <template v-if="typePanier === 'drive' && isEligibleAbonnementLad && !isPro">
              <AbonnementLadBanniereAbonne
                v-if="abonnementInCurrentMagasin"
                :date-fin="abonnementInCurrentMagasin.attributes.date_fin"
                :montant-manquant="
                  montantManquantLAD > 0 ? montantManquantLAD : null
                "
                class="u-mb-md Desk_Panier_LAD"
              />
              <AbonnementLadBanniereRenouvellement
                v-else-if="!hasAbonnementInPanier && !aboLadMaxAtteint && abonnementExpireInCurrentMagasin && !isClosedLad"
                class="u-mb-md"
                @close="closeLadBanner"
              />
              <AbonnementLadBanniereNonAbonne
                v-else-if="!hasAbonnementInPanier && !aboLadMaxAtteint && !isClosedLad"
                class="u-mb-md Desk_Panier_LAD"
                @close="closeLadBanner"
              />
            </template>
            <Card
              v-for="section in lignesBySections"
              :key="section.valeur"
              class="c-panier__card Desk_Panier_Produits"
            >
              <ProductCategory
                :alcool="section.alcool"
                class="c-panier__category"
              >
                <template #title>
                  <h2 class="c-panier__category-title">
                    {{ section.libelle }}
                    <span class="c-panier__category-title-quantity">
                      ({{ getNbProduits(section.articles) }}
                      {{ pluralize(getNbProduits(section.articles), "produit") }})
                    </span>
                  </h2>
                </template>
                <ItemContainer
                  v-for="(article, index) in section.articles"
                  :key="`${index}-${article.id}`"
                  :component="
                    article.type === 'ABO'
                      ? ProductCategoryItemAbonnement
                      : ProductCategoryItem
                  "
                  :cart-context="trackingCodes.LABELGA.Panier"
                  :article="article"
                  :index="index"
                  :type-panier="typePanier"
                  :show-recettes="showRecettes"
                  :show-substitution="showSubstitution"
                  class="c-panier__product"
                />
              </ProductCategory>
            </Card>
          </Accordion>
          <ButtonGroup class="u-my-lg20">
            <ButtonIcon
              class="Desk_Panier_Precedent"
              outline
              variant="primary"
              icon-position="left"
              icon-name="arrow-left"
              icon-color="primary"
              icon-size="sm"
              radius="full"
              size="md"
              to="/"
            >
              Continuer mes achats
            </ButtonIcon>
            <ButtonIcon
              icon-position="left"
              icon-name="trash"
              icon-color="grey-9"
              size="sm"
              icon-size="sm"
              class="u-color-grey-9 Desk_Panier_Vider"
              @click="$refs.confirmClear.show()"
            >
              Vider mon panier
            </ButtonIcon>
          </ButtonGroup>

          <div
            v-if="typePanier === 'drive' && pushListPanierProduits && getPushData(Panierpagecodes.PANIER_MEA)"
            class="u-bgcolor-white c-panier-selection u-radius-md"
          >
            <div class="c-panier-selection__selection">
              <HtmlParser
                promo-printing
                :push-data="getPushData(Panierpagecodes.PANIER_MEA)"
                class="u-overflow-hidden u-radius-top-left-md u-radius-bottom-left-md"
              />
            </div>
            <PushProductsBlock
              :label="trackingCodes.LABELGA.Panier"
              :products="pushListPanierProduits"
              :slides-offset="8"
              light
              class="c-panier-selection__list"
            />
          </div>

          <div
            v-if="smartliste && smartliste.length > 0 && typePanier === 'drive'"
            class="u-bgcolor-white u-radius-md u-pt-sm u-mt-lg20"
          >
            <Titre
              tag="h2"
              size="md"
              variant="primary"
              class="u-pl-sm u-mb-sm"
            >
              Êtes vous sûr(e) de n'avoir rien oublié ?
            </Titre>
            <PushProductsBlock
              :label="trackingCodes.LABELGA.Panier"
              :products="smartliste"
              :slides-offset="8"
              product-separator
              light
            />
          </div>
          <div
            v-if="typePanier === 'drive' && pushListDevantCaisse.length > 0"
            class="u-bgcolor-white u-radius-md u-pt-sm u-mt-lg20 Desk_Panier_Tuiles_Caisse"
          >
            <Titre
              tag="h2"
              size="md"
              variant="primary"
              class="u-pl-sm u-mb-sm"
            >
              {{ getPushTitle(Panierpagecodes.PRODUITS_DEVANTCAISSE) }}
            </Titre>
            <PushProductsBlock
              :label="trackingCodes.LABELGA.Panier"
              :products="pushListDevantCaisse"
              :slides-offset="8"
              product-separator
              light
            />
          </div>
        </div>
        <OrderSummary
          class="u-sticky u-flex-shrink-none Desk_Panier_Total"
          style="width:34rem"
          :type-panier="typePanier"
          @validate="goTunnel()"
        />
      </div>
    </template>
    <Popin
      ref="addToListe"
      aria-label="Ajouter à une liste"
      size="lg"
    >
      <PanierToListeForm
        :type-panier="typePanier"
        @saved="$refs.addToListe.hide()"
      />
    </Popin>
  </Container>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/panier.scss";
</style>
